import { render } from "./CNAMEdit.vue?vue&type=template&id=3cd1daa0"
import script from "./CNAMEdit.vue?vue&type=script&lang=js"
export * from "./CNAMEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__